// extracted by mini-css-extract-plugin
export default {"error":"NotFoundPage_error__5fFCT","container":"NotFoundPage_container__-vsTl"};